import { useEffect, useState } from "react";
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    Form,
    FormGroup,
    Input,
    Table,
    Container,
    Row,
    Col,
    Label,
    UncontrolledDropdown,
    DropdownMenu,
    DropdownItem,
    DropdownToggle,
} from "reactstrap";
import axios from "axios";
import Header from "components/Headers/Header";
import Loader from "components/Loader"; // ✅ Import do loader

const API_URL = process.env.REACT_APP_API_URL;

const Shortener = () => {
    const [utm, setUtm] = useState({
        baseUrl: "",
        source: "",
        medium: "",
        campaign: "",
        campaignId: "",
        content: "",
    });

    const [links, setLinks] = useState([]);
    const [generatedUrl, setGeneratedUrl] = useState("");
    const [loadingLinks, setLoadingLinks] = useState(true); // ✅ Estado do loader

    const fetchLinks = async () => {
        setLoadingLinks(true);
        try {
            const res = await axios.get(`${API_URL}/shortlinks`);
            setLinks(res.data);
        } catch (err) {
            console.error("Erro ao buscar links:", err);
        } finally {
            setLoadingLinks(false);
        }
    };

    useEffect(() => {
        fetchLinks();
    }, []);

    const handleChange = (e) => {
        setUtm({ ...utm, [e.target.name]: e.target.value });
    };

    const generateUtmLink = () => {
        const { baseUrl, source, medium, campaign, campaignId, content } = utm;
        if (!baseUrl) return "";

        const params = new URLSearchParams();

        if (source) params.append("utm_source", source);
        if (medium) params.append("utm_medium", medium);
        if (campaign) params.append("utm_campaign", campaign);
        if (campaignId) params.append("utm_id", campaignId);
        if (content) params.append("utm_content", content);

        const separator = baseUrl.includes("?") ? "&" : "?";
        return `${baseUrl}${separator}${params.toString()}`;
    };

    const handleGeneratePreview = () => {
        const url = generateUtmLink();
        setGeneratedUrl(url);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const finalUrl = generateUtmLink();
        if (!finalUrl) return;

        try {
            await axios.post(`${API_URL}/shortlinks`, { originalUrl: finalUrl });
            setUtm({
                baseUrl: "",
                source: "",
                medium: "",
                campaign: "",
                campaignId: "",
                content: "",
            });
            setGeneratedUrl("");
            fetchLinks();
        } catch (err) {
            console.error("Erro ao encurtar:", err);
        }
    };

    const handleDelete = async (code) => {
        const confirm = window.confirm("Tem certeza que deseja apagar este link?");
        if (!confirm) return;

        try {
            await axios.delete(`${API_URL}/shortlinks/${code}`);
            fetchLinks();
        } catch (err) {
            console.error("Erro ao apagar link:", err);
            alert("Erro ao apagar link");
        }
    };

    const handleCopy = (shortUrl) => {
        navigator.clipboard.writeText(shortUrl);
        alert("🔗 Link copiado para a área de transferência!");
    };

    return (
        <>
            <Header />
            <Container className="mt--7" fluid>
                {/* 🔹 Gerador de UTM */}
                <Row>
                    <Col xl="12">
                        <Card className="shadow">
                            <CardHeader>
                                <h3 className="mb-0">🎯 Gerador de UTM + Encurtador</h3>
                            </CardHeader>
                            <CardBody>
                                <Form onSubmit={handleSubmit}>
                                    <Row>
                                        <Col md="6">
                                            <FormGroup>
                                                <Label>URL base *</Label>
                                                <Input
                                                    type="url"
                                                    name="baseUrl"
                                                    placeholder="https://exemplo.com/pagina"
                                                    value={utm.baseUrl}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <Label>utm_source</Label>
                                                <Input
                                                    type="text"
                                                    name="source"
                                                    placeholder="facebook, google, email..."
                                                    value={utm.source}
                                                    onChange={handleChange}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <Label>utm_medium</Label>
                                                <Input
                                                    type="text"
                                                    name="medium"
                                                    placeholder="cpc, social, organic..."
                                                    value={utm.medium}
                                                    onChange={handleChange}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <Label>utm_campaign</Label>
                                                <Input
                                                    type="text"
                                                    name="campaign"
                                                    placeholder="campanha_exemplo"
                                                    value={utm.campaign}
                                                    onChange={handleChange}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <Label>utm_id (Campaign ID)</Label>
                                                <Input
                                                    type="text"
                                                    name="campaignId"
                                                    placeholder="Ex: 12345"
                                                    value={utm.campaignId}
                                                    onChange={handleChange}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <Label>utm_content</Label>
                                                <Input
                                                    type="text"
                                                    name="content"
                                                    placeholder="Ex: botao_azul, teste_A"
                                                    value={utm.content}
                                                    onChange={handleChange}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>

                                    <div className="d-flex align-items-center gap-3">
                                        <Button
                                            color="secondary"
                                            type="button"
                                            onClick={handleGeneratePreview}
                                        >
                                            Gerar UTM Preview
                                        </Button>
                                        <Button color="primary" type="submit">
                                            Encurtar Link
                                        </Button>
                                    </div>

                                    {generatedUrl && (
                                        <div className="mt-3 p-3 bg-light rounded">
                                            <strong>🔗 URL Gerada:</strong>
                                            <p style={{ wordBreak: "break-word" }}>{generatedUrl}</p>
                                        </div>
                                    )}
                                </Form>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                {/* 🔹 Tabela de links encurtados */}
                <Row className="mt-4">
                    <Col xl="12">
                        <Card className="shadow">
                            <CardHeader>
                                <h3 className="mb-0">🔗 Links Encurtados</h3>
                            </CardHeader>
                            <CardBody>
                                {loadingLinks ? (
                                    <div className="text-center py-5">
                                        <Loader />
                                    </div>
                                ) : (
                                    <Table responsive>
                                        <thead className="thead-light">
                                            <tr>
                                                <th>🔗 Encurtado</th>
                                                <th>🌐 Original</th>
                                                <th className="text-right">⚙️ Ações</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {links.map((link) => {
                                                const shortUrl = `${window.location.origin}/s/${link.code}`;
                                                const originalAbreviado =
                                                    link.originalUrl.length > 60
                                                        ? link.originalUrl.slice(0, 60) + "..."
                                                        : link.originalUrl;

                                                return (
                                                    <tr key={link.code}>
                                                        <td>
                                                            <a
                                                                href={shortUrl}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="font-weight-bold text-primary"
                                                            >
                                                                {shortUrl}
                                                            </a>
                                                        </td>
                                                        <td
                                                            className="text-truncate"
                                                            style={{ maxWidth: "400px" }}
                                                        >
                                                            {originalAbreviado}
                                                        </td>
                                                        <td className="text-right">
                                                            <UncontrolledDropdown>
                                                                <DropdownToggle
                                                                    className="btn-icon-only text-light"
                                                                    href="#pablo"
                                                                    role="button"
                                                                    size="sm"
                                                                    color=""
                                                                    onClick={(e) => e.preventDefault()}
                                                                >
                                                                    <i className="fas fa-ellipsis-v" />
                                                                </DropdownToggle>
                                                                <DropdownMenu
                                                                    container="body"
                                                                    className="dropdown-menu-arrow"
                                                                    right
                                                                >
                                                                    <DropdownItem
                                                                        onClick={() => handleCopy(shortUrl)}
                                                                    >
                                                                        📋 Copiar
                                                                    </DropdownItem>
                                                                    <DropdownItem
                                                                        tag="a"
                                                                        href={link.originalUrl}
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                    >
                                                                        🔎 Ver Original
                                                                    </DropdownItem>
                                                                    <DropdownItem
                                                                        onClick={() => handleDelete(link.code)}
                                                                        className="text-danger"
                                                                    >
                                                                        🗑️ Deletar
                                                                    </DropdownItem>
                                                                </DropdownMenu>
                                                            </UncontrolledDropdown>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </Table>
                                )}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default Shortener;